/*
 * Copyright (c) 2021 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, January 2021
 */

import React from 'react';
import {
  styled,
  TextWrapper,
  Theme,
  TouchableOpacity,
} from '@staffino/primitive-controls';
import { FlowBlockLink } from '@staffino/model';

const Link = styled(TouchableOpacity)((props: { theme?: Theme }) => ({
  lineHeight: 1.6,
  cursor: 'pointer',
  color: props.theme.colors.action,
  alignSelf: 'center',
}));

type Props = {
  block: FlowBlockLink;
  onClick?: (event: React.SyntheticEvent) => void;
};

export default function LinkBox({ block, onClick, ...rest }: Props) {
  return (
    <Link onPress={(event) => onClick?.(event)} {...rest}>
      <TextWrapper>{block.text}</TextWrapper>
    </Link>
  );
}
